module.exports = "https://static.wmbcdn.com/uniweb/images/78a3e2124ce59d58d79f2cd794d33b7a.svg";